import React, { useEffect, useRef, useState } from "react";
import { Document, Page } from "react-pdf";
import { useSelector } from "react-redux";
import { PDFDocument } from "pdf-lib";
import { base64ToArrayBuffer } from "../../utils/general";
import PrevNext from "./PrevNext";
import { BookmarkIcon, StarIcon } from "@heroicons/react/16/solid";
// import { maxFileSize } from "../../constant/const";

function RenderAllPdfPage(props) {
  const maxFileSize = 20;
  const pageContainer = useRef();
  const mergePdfInputRef = useRef(null);
  const [pageSigners, setPageSigners] = useState({}); // { pageNumber: [{ signerId, signerName, color }] }
  const isHeader = true;
  const [pageWidth, setPageWidth] = useState("");

  //set all number of pages after load pdf
  function onDocumentLoad({ numPages }) {
    // console.log("numPages", numPages);
    props?.setAllPages(numPages);
    //check if signerPos array exist then save page number exist in signerPos array to show bookmark icon
    if (props?.signerPos) {
      let pageSignersMap = {};

      // Iterate through all signers in signerPos array
      props?.signerPos?.forEach((signer) => {
        if (signer?.placeHolder && signer.placeHolder.length > 0) {
          // Check each placeholder for widgets
          signer.placeHolder.forEach((data) => {
            // Check if the placeholder has any widgets (pos array)
            if (data?.pageNumber && data?.pos && data.pos.length > 0) {
              const pageNum = data?.pageNumber;
              if (!pageSignersMap[pageNum]) {
                pageSignersMap[pageNum] = [];
              }
              pageSignersMap[pageNum].push({
                signerId: signer.Id,
                signerName: signer.name,
                color: signer?.blockColor || signer?.color || "red",
              });
            }
          });
        }
      });

      setPageSigners(pageSignersMap);
    }
  }

  useEffect(() => {
    onDocumentLoad({ numPages: props?.allPages });
  }, [props?.signerPos]);
  useEffect(() => {
    const updateSize = () => {
      if (pageContainer.current) {
        setPageWidth(pageContainer.current.offsetWidth);
      }
    };

    // Use setTimeout to wait for the transition to complete
    const timer = setTimeout(updateSize, 100); // match the transition duration

    return () => clearTimeout(timer);
  }, [isHeader, pageContainer, props?.containerWH]);
  //'function `addSignatureBookmark` is used to display the page where the user's signature is located.
  const addSignatureBookmark = (index) => {
    const pageNum = index + 1;
    const signersOnPage = pageSigners[pageNum] || [];

    if (signersOnPage.length === 0) {
      return null;
    }

    return (
      <div className="absolute z-10 top-[1px] left-[-10px] flex flex-col gap-1">
        {signersOnPage.map((signer, signerIndex) => (
          <div
            key={`${signer.signerId}-${signerIndex}`}
            className="flex items-center gap-1 bg-white rounded-full px-1 py-1 shadow-sm border"
            style={{ borderColor: signer.color }}
          >
            <BookmarkIcon className="w-3 h-3" style={{ color: signer.color }} />
            {/* <div
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: signer.color }}
            ></div> */}
            {/* <span
              className="text-xs font-medium"
              style={{ color: signer.color }}
            >
              {signer.signerName}
            </span> */}
          </div>
        ))}
      </div>
    );
  };
  const pdfDataBase64 = `data:application/pdf;base64,${props?.pdfBase64Url}`;

  // `removeFile` is used to  remove file if exists
  const removeFile = (e) => {
    if (e) {
      e.target.value = "";
    }
  };
  // `handleFileUpload` is trigger when user click on add pages btn and is used to merge multiple pdf
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      alert("Please upload a valid file.");
      return;
    }

    // Validate file type - PDF only for Add pages (merge)
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed for adding pages.");
      removeFile(e);
      return;
    }

    const mb = Math.round(file?.size / Math.pow(1024, 2));
    if (mb > maxFileSize) {
      alert(`File size must be less than ${maxFileSize} MB`);
      removeFile(e);
      return;
    }

    try {
      const uploadedPdfBytes = await file.arrayBuffer();

      const uploadedPdfDoc = await PDFDocument.load(uploadedPdfBytes, {
        ignoreEncryption: true,
      });
      const basePdfDoc = await PDFDocument.load(props.pdfArrayBuffer);

      // Copy pages from the uploaded PDF to the base PDF
      const uploadedPdfPages = await basePdfDoc.copyPages(
        uploadedPdfDoc,
        uploadedPdfDoc.getPageIndices(),
      );
      uploadedPdfPages.forEach((page) => basePdfDoc.addPage(page));
      // Save the updated PDF
      const pdfBase64 = await basePdfDoc.saveAsBase64({
        useObjectStreams: false,
      });
      const pdfBuffer = base64ToArrayBuffer(pdfBase64);
      props.setPdfArrayBuffer(pdfBuffer);
      props.setPdfBase64Url(pdfBase64);
      props.setIsUploadPdf && props.setIsUploadPdf(true);
      mergePdfInputRef.current.value = "";
    } catch (error) {
      mergePdfInputRef.current.value = "";
      console.error("Error merging PDF:", error);
      alert(
        error.message ||
          "Failed to add pages. Please ensure the file is valid and try again.",
      );
    }
  };
  return (
    <div ref={pageContainer}>
      {props?.shopPageArrow && (
        <div className="flex justify-between items-center p-4">
          <PrevNext
            pageNumber={props?.pageNumber}
            allPages={props?.allPages}
            changePage={props?.changePage}
          />
        </div>
      )}
      {props?.shopPageArrow && <hr />}
      <div
        className={`flex h-[90%] flex-col items-center
         autoSignScroll hide-scrollbar max-h-[90vh] `}
      >
        <Document
          error=""
          loading={"Loading..."}
          onLoadSuccess={onDocumentLoad}
          file={pdfDataBase64}
        >
          {Array.from(new Array(props?.allPages), (el, index) => (
            <div
              key={index}
              className={`shadow-md rounded-md p-2 ${
                props?.pageNumber - 1 === index
                  ? "border-primary"
                  : "border-gray-400"
              } border m-[10px] flex justify-center items-center relative`}
              onClick={() => {
                props?.setPageNumber(index + 1);
                if (props?.setSignBtnPosition) {
                  props?.setSignBtnPosition([]);
                }
              }}
            >
              {props?.signerPos && addSignatureBookmark(index)}
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={pageWidth - 60}
                scale={1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                className="rounded-sm"
              />
            </div>
          ))}
        </Document>
        {props?.isMergePdfBtn && (
          <button
            className="mb-2 bg-base-100 px-2 py-2 ring-[0.5px] ring-base-content rounded-box flex gap-1 justify-center items-center"
            onClick={() => mergePdfInputRef.current.click()}
            title={"Add pages"}
          >
            <input
              type="file"
              className="hidden"
              accept=".pdf"
              ref={mergePdfInputRef}
              onChange={handleFileUpload}
            />
            <i className="fa-light fa-plus text-gray-500"></i>
            <span className="text-xs lg:text-sm text-base-content ">
              Add pages
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default RenderAllPdfPage;
